module.exports = __webpack_public_path__ + "static/media/ISOFIT_RGB.4cf7f47a.png";